__turbopack_context__.v({
  "recommended-widget": "Recommended-module-scss-module__bue_rq__recommended-widget",
  "recommended-widget__attribution": "Recommended-module-scss-module__bue_rq__recommended-widget__attribution",
  "recommended-widget__header": "Recommended-module-scss-module__bue_rq__recommended-widget__header",
  "recommended-widget__list": "Recommended-module-scss-module__bue_rq__recommended-widget__list",
  "recommended-widget__subtitle": "Recommended-module-scss-module__bue_rq__recommended-widget__subtitle",
  "recommended-widget__wordmark": "Recommended-module-scss-module__bue_rq__recommended-widget__wordmark",
  "story": "Recommended-module-scss-module__bue_rq__story",
  "story__abstract": "Recommended-module-scss-module__bue_rq__story__abstract",
  "story__text": "Recommended-module-scss-module__bue_rq__story__text",
  "story__thumb": "Recommended-module-scss-module__bue_rq__story__thumb",
  "story__title": "Recommended-module-scss-module__bue_rq__story__title",
});
